import {createContext, useContext} from 'react';

import type {ThemeContextProps} from './types';

// The context object and its hook live in this JSX-free module so that
// ThemeProvider.tsx only exports a component and keeps its Fast Refresh
// boundary. Consumers keep importing `useDarkMode` from
// '@/context/ThemeProviderContext'.
export const ThemeContext = createContext<ThemeContextProps | undefined>(
  undefined,
);

export const useDarkMode = (): ThemeContextProps => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useDarkMode must be used within a ThemeProvider');
  }
  return context;
};
